"use strict";
var FlightRequirementTypes = (function () {
    function FlightRequirementTypes() {
    }
    return FlightRequirementTypes;
}());
FlightRequirementTypes.required = 'Required';
FlightRequirementTypes.optional = 'Optional';
FlightRequirementTypes.conditional = 'Conditional';
FlightRequirementTypes.none = 'None';
exports.FlightRequirementTypes = FlightRequirementTypes;
//# sourceMappingURL=D:/a/1/s/base/src/models/flight-requirement-types.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/base/src/models/flight-requirement-types.model.js